import './StackGalleryCard.css';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

// import required modules
import { EffectCards } from 'swiper/modules';
import { API_BASE_URL } from '../../utils';

const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function StackGalleryCard({ imagesToShow }) {
    console.log("images in stack ", imagesToShow);

    return (
        <>
            <Swiper
                effect={'cards'}
                grabCursor={true}
                modules={[EffectCards]}
                className="StackGalleryCard-container"
            >
                {imagesToShow && imagesToShow.map((image, index) => (
                    <SwiperSlide key={index}  >
                        <img
                            className="StackGalleryCard"
                            src={url + image.img}   // 👈 FIXED
                            alt={`Slide ${index + 1}`}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                    "https://images.unsplash.com/photo-1468465236047-6aac20937e92?w=600&auto=format&fit=crop&q=60";
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </>
    )
}
